<template>
	<SearchListLayout
		ref="layout"
		class="d-employee-list"
		v-bind="{
			...$props,
			...$attrs,
			headerGraphic: 3,
			searchArea,
			searchConfig: {
				enableGroupedSearch: isGrouped,
				limit: isGrouped
					? {
							1: 6,
							2: 6,
							3: 6,
							4: 6,
							5: 6,
							6: 6, // don't know if there will be more than 5
							7: 6,
					  }
					: 12,
			},
			fetchMoreFunction: 'fetchAll',
			defaults: getDefaults({
				text: '',
				areas: '',
				departments: '',
				locations: '',
			}),
			hideLayoutPickerOnMobile: true,
			defaultLayout: 'list',
		}"
	>
		<template #searchFields="{ fieldsByName, action }">
			<div
				class="
					d-employee-list__search-fields
					grid grid-cols-12
					gap-x-3xs/h gap-y-2xs/v
					>=1024:mt-8
					pt-lg/v
					pb-sm/v
				"
			>
				<div class="col-span-12">
					<SearchTextInput
						v-if="fieldsByName.text"
						v-bind="{
							...fieldsByName.text,
							type: 'search',
						}"
						v-model="tempSearchValue.text"
						@keyup.native.enter="
							() => submitText(fieldsByName, action.submit)
						"
					>
						<BaseButton
							aria-label="Udfør søgning"
							class="
								w-48
								>=768:w-52
								h-48
								>=768:h-52
								p-0
								rounded-full
							"
							@click="
								() => submitText(fieldsByName, action.submit)
							"
						>
							<SvgIconSearch class="w-18 h-18" />
						</BaseButton>
					</SearchTextInput>
				</div>

				<!-- Row of dropdowns -->
				<div
					class="
						col-span-12
						grid
						>=768:contents
						grid-cols-12
						gap-8
						>=768:gap-x-3xs/h >=768:gap-y-2xs/v
					"
				>
					<SearchDropdown
						v-if="fieldsByName.areas"
						v-bind="fieldsByName.areas"
						v-model="fieldsByName.areas.value"
						class="col-span-12 >=768:col-span-6"
						:class="{
							'>=1200:col-span-4':
								fieldsByName.areas &&
								fieldsByName.departments &&
								fieldsByName.locations,
						}"
						show-icon
						@input="() => action.submit()"
					/>

					<SearchDropdown
						v-if="fieldsByName.departments"
						v-bind="fieldsByName.departments"
						v-model="fieldsByName.departments.value"
						class="col-span-12 >=768:col-span-6"
						:class="{
							'>=1200:col-span-4':
								fieldsByName.areas &&
								fieldsByName.departments &&
								fieldsByName.locations,
						}"
						@input="() => action.submit()"
					/>

					<SearchDropdown
						v-if="fieldsByName.locations"
						v-bind="fieldsByName.locations"
						v-model="fieldsByName.locations.value"
						class="col-span-12 >=768:col-span-6"
						:class="{
							'>=1200:col-span-4':
								fieldsByName.areas &&
								fieldsByName.departments &&
								fieldsByName.locations,
						}"
						@input="() => action.submit()"
					/>
				</div>
			</div>
		</template>
	</SearchListLayout>
</template>

<script>
import SearchListLayout from '~/components/main/SearchListLayout';
import SearchTextInput from '~/components/main/SearchTextInput';
import SearchDropdown from '~/components/main/SearchDropdown';
import SvgIconSearch from '~/assets/svgs/icon-search.svg?inline';

export default {
	name: 'MainEmployeeList',

	components: {
		SearchListLayout,
		SearchTextInput,
		SearchDropdown,
		SvgIconSearch,
	},
	inheritAttrs: false,

	props: {
		template: String,
	},

	data() {
		const defaults = this.getDefaults();
		return {
			isGrouped: (this.$attrs.search?.endpointUrl || '').endsWith(
				'/grouped'
			),
			tempSearchValue: {
				text:
					'text' in this.$route.query
						? this.$route.query.text ?? ''
						: defaults.text ?? '',
			},
			searchArea:
				this.template === 'expertList'
					? {
							singular: 'ekspert',
							plural: 'eksperter',
					  }
					: {
							singular: 'medarbejder',
							plural: 'medarbejdere',
					  },
		};
	},

	methods: {
		getDefaults(obj = {}) {
			const { fields = [] } = this.$attrs.search || {};
			const newObj = fields
				.filter((field) => 'defaultValue' in field)
				.reduce((acc, field) => {
					acc[field.name] = field.defaultValue;
					return acc;
				}, obj);
			return { ...obj, ...newObj };
		},
		submitText(fieldsByName, submit) {
			let changed = false;

			if (
				'text' in fieldsByName &&
				fieldsByName.text.value !== this.tempSearchValue.text
			) {
				fieldsByName.text.value = this.tempSearchValue.text;
				changed = true;
			}
			if (
				'includePhrase' in fieldsByName &&
				fieldsByName.includePhrase.value !==
					this.tempSearchValue.includePhrase
			) {
				fieldsByName.includePhrase.value =
					this.tempSearchValue.includePhrase;
				changed = true;
			}
			if (
				'includeWords' in fieldsByName &&
				fieldsByName.includeWords.value !==
					this.tempSearchValue.includeWords
			) {
				fieldsByName.includeWords.value =
					this.tempSearchValue.includeWords;
				changed = true;
			}
			if (
				'excludeWords' in fieldsByName &&
				fieldsByName.excludeWords.value !==
					this.tempSearchValue.excludeWords
			) {
				fieldsByName.excludeWords.value =
					this.tempSearchValue.excludeWords;
				changed = true;
			}

			changed && submit();
		},
	},
};
</script>
